const AzureAuthenticationTitle = ({ record }) => {
    return <span>Azure Auth {record ? `"${record.client_id}"` : ''}</span>;
};

export default AzureAuthenticationTitle;